import { REPORT_PERMISSION } from 'modules/campaigns/config/reportPermissions';
import { useAvailableItems } from '../../../hooks';
import { isAdminNetworkAccountType, isNetworkSubAccount } from '../../../modules/account-management/accountType';
import { MODULE_NAME } from '../../../modules/campaigns/config';
import {
    FEATURE_FLAGS,
    useAccount,
    useIsAppAccountNetwork,
} from '../../../modules/taboola-common-frontend-modules/account-configurations';
import { BreadcrumbsAccountPicker } from '../components/BreadcrumbsAccountPicker/BreadcrumbsAccountPicker';
import { BreadcrumbsCampaignGroupPicker } from '../components/BreadcrumbsCampaignGroupPicker/BreadcrumbsCampaignGroupPicker';
import { BreadcrumbsCampaignPicker } from '../components/BreadcrumbsCampaignPicker/BreadcrumbsCampaignPicker';

const stepConfig = [
    {
        id: 'root-account-picker',
        component: BreadcrumbsAccountPicker,
        visibilityCondition: ({ accountSelectionAllowed }) => accountSelectionAllowed,
        componentProps: { isRoot: true },
    },
    {
        id: 'account-picker',
        component: BreadcrumbsAccountPicker,
        visibilityCondition: ({ accountSelectionAllowed, isAppAccountNetwork, account }) =>
            accountSelectionAllowed && (isAppAccountNetwork || isNetworkSubAccount(account)),
    },
    {
        id: 'campaign-group-picker',
        component: BreadcrumbsCampaignGroupPicker,
        permissions: [REPORT_PERMISSION.CAMPAIGN_GROUPS_REPORT_VIEW],
        accountConfigurations: { [FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED]: 'true' },
        visibilityCondition: ({ module, account }) => module === MODULE_NAME && !isAdminNetworkAccountType(account),
    },
    {
        id: 'campaign-picker',
        component: BreadcrumbsCampaignPicker,
        permissions: [REPORT_PERMISSION.ADS_CONSOLE_CAMPAIGNS_REPORT],
        visibilityCondition: ({ module }) => module === MODULE_NAME,
    },
];

export const useBreadcrumbsPickerData = ({ accountSelectionAllowed }) => {
    const isAppAccountNetwork = useIsAppAccountNetwork();
    const account = useAccount();
    const availableItems = useAvailableItems(stepConfig, { accountSelectionAllowed, isAppAccountNetwork, account });

    return availableItems;
};
